import script from "./AssistenteIAFloating.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistenteIAFloating.vue?vue&type=script&setup=true&lang=js"

import "./AssistenteIAFloating.vue?vue&type=style&index=0&id=2a6ba5b3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\prestito-si-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6ba5b3"]])

export default __exports__